import { Check, Pencil, Trash2, X } from "lucide-react";
import React from "react";
import { Button } from "../../../../../components/ui/common/button";
import { cn } from "../../../../../lib/utils";

interface RowActionsProps {
  editing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  /** When provided, a trash icon button is shown in view mode. */
  onDelete?: () => void;
  /** Size classes for each icon button. Override for denser tables. */
  buttonClassName?: string;
  disabled?: boolean;
}

const RowActions: React.FC<RowActionsProps> = ({
  editing,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  buttonClassName = "tw-h-8 tw-w-8",
  disabled = false
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
      {editing ? (
        <>
          <Button
            variant="ghost"
            size="icon"
            className={cn(buttonClassName, "tw-text-primary")}
            onClick={onSave}
            disabled={disabled}
            title="Save"
          >
            <Check className="tw-h-3.5 tw-w-3.5" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className={buttonClassName}
            onClick={onCancel}
            disabled={disabled}
            title="Cancel"
          >
            <X className="tw-h-3.5 tw-w-3.5" />
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="ghost"
            size="icon"
            className={buttonClassName}
            onClick={onEdit}
            disabled={disabled}
            title="Edit"
          >
            <Pencil className="tw-h-3.5 tw-w-3.5" />
          </Button>
          {onDelete && (
            <Button
              variant="ghost"
              size="icon"
              className={cn(buttonClassName, "tw-text-destructive hover:tw-text-destructive")}
              onClick={onDelete}
              disabled={disabled}
              title="Delete"
            >
              <Trash2 className="tw-h-3.5 tw-w-3.5" />
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export default RowActions;
